/**
 * @class Dimension
 */
export default class Dimension {
    /**
     * @param {number} rows
     * @param {number} columns
     * @constructor
     */
    constructor(rows, columns) {
        if (rows <= 0) {
            throw new Error('Dimension() - Rows value has to be > 0');
        }
        if (columns <= 0) {
            throw new Error('Dimension() - Columns value has to be > 0');
        }

        this.rows = parseInt(rows, 10);
        this.columns = parseInt(columns, 10);
    }

    /**
     * @return {number}
     */
    getRows() {
        return this.rows;
    }

    /**
     * @return {number}
     */
    getColumns() {
        return this.columns;
    }

    getRatio() {
        return this.rows / this.columns;
    }
}
